import React , { useEffect, useState } from 'react';
import { Layout, Footer,InfoBox } from 'components';

import { Modal } from 'antd';
import PackageBoxes from './partials/boxes';
import Payment from './partials/payment';
import './packages.less';
import 'components/box/box.less';
import 'components/tabs/tabs.less';
import 'components/Radio/radio-group.less';

import { getPackageList, getUserStatus } from 'services/omcc.service';
import { customMessages } from 'utils';
import { PackageProvider } from 'context/package.context';

const PackagesPage = () =>
{
  const [packageList, setPackageList] = useState([]);
  const [selectedItem] = useState(null);
  const [userStatus, setUserStatus] = useState(
    {
      isAuthorized:false,
      isMaster:false,
      type:'',
      paymentType:'',
      currentToS:'',
      currentAgreement:''
    });

  useEffect(() =>
  {
   
    getUserAuthStatus();
  }, [])

  const getPackages = () =>
  {
    getPackageList().then((result) =>
    {
      setPackageList(result.packageList);
    }).catch((response) =>
    {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }

  const getUserAuthStatus = () =>
  {
    getUserStatus().then((result) =>
    {
      setUserStatus(
        {
          isAuthorized: result.isAuthorized,
          isMaster:result.isMaster,
          type:result.type,
          paymentType:result.paymentType,
          currentToS:result.currentAgreement,
          currentAgreement:result.currentToS
        });
       if  (result.type=="KURUMSAL" && result.isAuthorized && result.isMaster)
       {
        getPackages();
       }
    }).catch((response) =>
    {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }

  return (
    <Layout>
      <PackageProvider>
      <div className="packages-page">
      {!userStatus.isMaster &&
         <div className="container">
         <InfoBox
           type="warning"
           content={
             customMessages.getMessage("otpUserNotAuthorized")
           }
         />
         </div>
        }
        {userStatus.type=="KURUMSAL" && userStatus.isAuthorized && userStatus.isMaster &&
          (
            <React.Fragment>
              <PackageBoxes list={packageList}   />
              <Payment  userStatus={userStatus} selectedItem={selectedItem} />
            </React.Fragment>
          ) 
        }
        {userStatus.type=="BIREYSEL" &&   userStatus.isMaster &&
        <div className="container">
        <InfoBox
          type="warning"
          content={
            customMessages.getMessage("indivualAccountNotAuthorized")
          }
        />
        </div>
        } 
        {userStatus.type=="KURUMSAL" && !userStatus.isAuthorized && userStatus.isMaster &&
        <div className="container"> <InfoBox
          type="warning"
          content={
            customMessages.getMessage("corporateAccountNotAuthorized")
          }
        /></div>
        }
     
      </div>
      <Footer /></PackageProvider>
    </Layout>
  );
};

export default PackagesPage;
